export default __webpack_public_path__ + "static/media/ExcelIcon.cf16d33f.svg";